import React from 'react';
import styled from 'styled-components';
import withBuyTogetherVip from '@catalogo/service-americanas-product/src/hocs/buy-together-vip';
import Checkbox from '@catalogo/theme-form-builder/src/components/checkbox';

const Title = styled.p`
  font-size: 14px;
`;

const Price = styled.p`
  font-size: 14px;
  font-weight: bold;
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 8px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px 5px;
  border: 1px solid #e5e5e5;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    border-radius: 4px;
    border: 0;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
  }
`;

export const BuyTogetherVip = ({
  loading,
  error,
  data,
  buyTogetherProductId,
  image,
  title,
  price,
  handleBuyTogether,
  isO2O,
}) => {
  if (!buyTogetherProductId || loading || error || !data || !price || isO2O) {
    return null;
  }

  return (
    <Container>
      <Checkbox onClick={handleBuyTogether} />
      <Image src={image} />
      <div>
        <Title>{title}</Title>
        <Price>+ R$ {price}</Price>
      </div>
    </Container>
  );
};

export default withBuyTogetherVip(BuyTogetherVip);
